import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import * as feather from 'feather-icons'
import {Title} from '@angular/platform-browser';
import {filter, mergeMap} from 'rxjs';
import {map} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {RecaptchaV3Service} from './core/services/recaptcha/recaptcha-v3-service';
import * as Sentry from '@sentry/angular';
import {AuthenticationService} from './core/services/authentication/authentication.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit, AfterViewInit {
  protected title = 'long-angular';

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly titleService: Title,
    private readonly translate: TranslateService,
    private readonly recaptchaService: RecaptchaV3Service,
    private readonly authenticationService: AuthenticationService,
  ) {
    // The TranslationService is automatically initialized when injected
    // No need to manually initialize it here
  }

  ngOnInit(): void {
    this.recaptchaService.load();
    this.router.events
      .pipe(
        filter((event: any) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        const userInfo = this.authenticationService.userData;
        if (userInfo) {
          Sentry.setUser({
            id: userInfo.id,
            username: userInfo.preferredUsername,
            email: userInfo.email
          });
        }
        else {
          Sentry.setUser(null);
        }

        const title = data['title'];
        if (!title) {
          this.titleService.setTitle('World Conquer Online');
          return;
        }
        this.translate.get(title).subscribe((translatedTitle: string) => {
          this.titleService.setTitle(`${translatedTitle} - World Conquer Online`);
        });
      });

  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    feather.replace();
  }
}
